import React, { useState, useEffect } from "react";
import { ApolloClient, ApolloProvider } from "@apollo/client";
import { createApolloClient } from "./createApolloClient";

type Props = {
  tenant?: string | null;
  children: React.ReactChild;
};

export const ProvisioningApolloProvider = ({ tenant, children }: Props): React.JSX.Element | null => {
  const [client, setClient] = useState<ApolloClient<any> | null>(null);

  useEffect(() => {
    if (tenant) {
      const apolloClient = createApolloClient(tenant);
      setClient(apolloClient);
    }
  }, [tenant, setClient]);

  return client ? <ApolloProvider client={client}>{children}</ApolloProvider> : null;
};
